import React, { useState } from "react"
import Pagination from "gatsby-theme-blank/src/components/Pagination/pagination"
import {
  results,
  resultsTop,
  resultsContainer,
} from "./listResults.module.scss"
import PropTypes from "prop-types"
import { useBuildData } from "gatsby-theme-blank/src/hooks/use-build-data"
import { ResultContainer, ResultsContainer } from "./results-taxo-styled"
import SearchFadeIn from "gatsby-theme-blank/src/components/search-fade-in"
import ResultItem from "./ResultItem/result-item"
import SearchFilters from "gatsby-theme-blank/src/components/search-filters"

//-----------------------Parent component---------------------------//

const ResultsTaxo = ({ resultats, pageContext }) => {
  const buildColors = useBuildData().theme_settings.palette
  const { currentPage, numPages, baseLink, slugTerm, nodesLength } = pageContext
  let tabType = []
  resultats.map(({ node }) => {
    tabType.push(node.internal.type)
    tabType = [...new Set(tabType)]
    return null
  })
  const [choosenType, setChoosenType] = useState(null)
  const toggleType = (typeChoisi, nameType) => {
    if (typeChoisi === nameType) {
      setChoosenType(null)
    } else {
      setChoosenType(nameType)
    }
  }

  if (choosenType !== null) {
    resultats = resultats.filter(({ node }) => {
      if (node.internal.type === choosenType) {
        return true
      }
      return false
    })
  }
  return (
    <ResultContainer className={results}>
      <div className={resultsTop}>
        <h3>
          {nodesLength} résultat(s) pour le terme &quot;{slugTerm}&quot;
        </h3>
      </div>
      <Pagination
        currentPage={currentPage}
        numPages={numPages}
        contextPage={baseLink}
      />
      <SearchFilters
        tabType={tabType}
        choosenType={choosenType}
        toggleType={toggleType}
      />
      <ResultsContainer className={resultsContainer} role={"list"}>
        {resultats.length === 0 && (
          <div>Pas de résultats, veuillez modifier votre requête</div>
        )}
        <SearchFadeIn delay={150}>
          {resultats.map(({ node }) => {
            return (
              <ResultItem
                colors={buildColors}
                key={node.drupal_id}
                result={node}
                role={"listitem"}
              />
            )
          })}
        </SearchFadeIn>
      </ResultsContainer>
      <Pagination
        currentPage={currentPage}
        numPages={numPages}
        contextPage={baseLink}
      />
    </ResultContainer>
  )
}
//-----------------------Parent component---------------------------//

//-----------------------Prop-Types---------------------------//

ResultsTaxo.propTypes = {
  resultats: PropTypes.array.isRequired,
  pageContext: PropTypes.object,
}

//-----------------------Prop-Types---------------------------//

export default ResultsTaxo
